/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var _ = require('underscore');

var cleanUpResponse = require('common/util/cleanUpResponse');

module.exports = function(data) {
  var defer = $.Deferred();

  $.soap({
    body: {
      GetClosedComplianceCases: {
        $xmlns: 'http://dobs.pa.gov/nd/compliance/bpm/1.0'
      }
    },
    blueprintArrays: ['GetClosedComplianceCasesResponse.ND_Compliance'],
    blueprint: {
      complianceCases: [
        '$..ND_Compliance',
        {
          id: '$.ID',
          administrator: '$.Administrator',
          complianceStatusId: '$.ComplianceStatusID',
          complianceStatus: '$.ComplianceStatus',
          licenseId: '$.LicenseID',
          entityId: '$.EntityID',
          caseNumber: '$.CaseNumber',
          entityName: '$.EntityName',
          licenseNumber: '$.LicenseNumber',
          licenseCode: '$.Code',
          unlicensedAsLicenseTypeId: '$.UnlicensedAsLicenseTypeID',
          unlicensedAsLicenseCode: '$.UnlicensedAsLicenseCode'
        }
      ]
    }
  })
    .done(function(response) {
      cleanUpResponse(response);
      _.each(response.complianceCases, function(complianceCase) {
        if (!complianceCase.licenseId) {
          complianceCase.licenseCode = 'UL - ' + complianceCase.unlicensedAsLicenseCode;
          complianceCase.licenseNumber = '--';
        }

        if (!complianceCase.administrator) {
          complianceCase.administrator = '--';
        }

        if (!complianceCase.caseNumber) {
          complianceCase.caseNumber = '--';
        }
      });

      defer.resolve(response.complianceCases);
    })
    .fail(function(err) {
      defer.reject(err);
    });

  return defer.promise();
};
